import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DisplayReportJob } from 'app/models/ui';
import { Store } from "@ngrx/store";
import { AppState } from "../../reducers";
import { ReportingActions } from "../../components/reporting/reporting.actions";
import { ReportingApi } from "../../services/webservice/reporting-api.service";
import { MessageActions } from "../../actions";

const fileSaver = require('../../FileSaver');


@Component({
	template: `
		<download-status-presentation
				[displayReportJobs]="displayReportJobs$ | async"
				(reportDownloadClicked)="downloadReport($event)"
				(deleteReportJobClicked)="deleteReportJob($event)"
		></download-status-presentation>
	`,
	selector: "download-status",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadStatusComponent {
	displayReportJobs$: Observable<DisplayReportJob[]>;

	constructor(
		private store: Store<AppState>,
		private reportingActions: ReportingActions,
		private reportingApi: ReportingApi,
		private messageActions: MessageActions
	) {
	}

	ngOnInit() {
		this.displayReportJobs$ = this.store.select("reporting", "reportJobs");
	}

	downloadReport(displayReportJob: DisplayReportJob) {
		this.reportingApi.fetchReportByJob(displayReportJob.reportJob.fetch).subscribe(blob => {
				fileSaver.saveAs(blob, displayReportJob.filename, true);
				this.store.dispatch(this.reportingActions.deleteDisplayReportJob(displayReportJob))
			},
			error => {
				this.store.dispatch((this.reportingActions.deleteDisplayReportJob(displayReportJob)))
				this.handleError(error);
			})
	}

	deleteReportJob(displayReportJob: DisplayReportJob) {
		this.store.dispatch(this.reportingActions.deleteDisplayReportJob(displayReportJob));
	}

	private handleError(error: any) {
		if (!error.messageDe) {
			error.messageDe = "Es ist ein unerwarteter Fehler beim Herunterladen Berichts aufgetreten.";
		}
		this.store.dispatch(this.messageActions.displayMessage(error.messageDe, "error"));
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/download-status/download-status.component.ts